export * from './mem-store';

import Vue, { VNode } from 'vue';
import memStore from './mem-store';
import * as colorConst from './color-const';
import statusInfoMap from './status-info-map';

export const utilService = {
  numberWithCommas(x: number): string {
    const parts = x.toString()
      .split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },
  getVueScopedSlot(scopedSlots: Vue['$scopedSlots'], slotName: string = 'default', props: any = {}): VNode[] {
    if (!scopedSlots) { return []; }
    const slot = scopedSlots[slotName];
    if (!slot) { return []; }
    const children = slot(props);
    return children || [];
  },
  memStore,
  colorConst,
  statusInfoMap,
};
